/* ============================================================================
   Sticky Add to Cart bar -- keep price, "was" price and button label in sync
   ----------------------------------------------------------------------------
   The sticky bar is built by an inline script in sections/main-product.liquid.
   That script takes a ONE-TIME copy of the price and button when the page
   loads. Two problems followed:

     1. Selecting a different variant updated the real price but the bar kept
        showing the price from page load (e.g. $74.00 instead of $102.00).
     2. It copies only the first `.price-list .price` (the sale price), so on
        discounted products the crossed-out original never appeared.

   This script fixes both, and keeps the button label (Add to Cart /
   Pre-Order / Sold Out) matching the real button.

   The theme REPLACES the price/button nodes on variant change rather than
   editing their text, so we observe the stable form container and re-read the
   live elements every time instead of holding references to old nodes.

   Every lookup is scoped to the main product form. An unscoped
   '.price-list .price' also matches product cards elsewhere on the page
   ("Recently viewed", recommendations, bundles) and was showing another
   product's price.

   Loaded with `defer`, so it runs after the inline builder has created the bar.
   Layout/styling lives in assets/sticky-bar-mobile.css.
   ========================================================================= */
(function () {
  'use strict';

  var FORM = 'form.product-form';

  function q(sel) {
    return document.querySelector(sel);
  }

  function syncStickyBar() {
    var stickyPrice = q('.sticky-price');
    var form = q(FORM);
    if (!stickyPrice || !form) return;

    // ---- 1. Sale / current price ----------------------------------------
    var liveSale = form.querySelector('.price-list .price:not(.price--compare)');
    var stickySale = stickyPrice.querySelector('.price:not(.price--compare)');
    if (liveSale && stickySale && stickySale.innerHTML !== liveSale.innerHTML) {
      stickySale.innerHTML = liveSale.innerHTML;
    }

    // ---- 2. Compare-at ("was") price ------------------------------------
    var liveCompare = form.querySelector('.price-list .price--compare');
    var stickyCompare = stickyPrice.querySelector('.price--compare');
    if (liveCompare) {
      if (stickyCompare) {
        if (stickyCompare.innerHTML !== liveCompare.innerHTML) {
          stickyCompare.innerHTML = liveCompare.innerHTML;
        }
      } else {
        stickyPrice.appendChild(liveCompare.cloneNode(true));
      }
    } else if (stickyCompare) {
      // New variant isn't discounted -- don't leave a stale "was" price
      stickyCompare.remove();
    }

    // ---- 3. Button label ------------------------------------------------
    // Qikify BoosterKit's clone is the visible buy button when present;
    // otherwise fall back to the theme's own submit button.
    var liveButton =
      form.querySelector('button.qbk-clone-button') ||
      form.querySelector('button[type=submit]');
    var stickyButton = q('.sticky-banner button');
    if (liveButton && stickyButton) {
      var label = liveButton.innerText.trim();
      if (label && stickyButton.innerText.trim() !== label) {
        stickyButton.innerText = label;
      }
    }
  }

  function init() {
    syncStickyBar();

    // We observe the form but only ever write inside .sticky-banner, which is
    // outside the form, so this cannot trigger itself.
    var form = q(FORM);
    if (form && window.MutationObserver) {
      new MutationObserver(syncStickyBar).observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
